import Color from 'color'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

import { ParagraphSmallCaps } from 'components/Paragraphs'

const SectionTitleContainer = styled.div`
  border-left: 4px solid ${({ theme }) => theme.purpleLight};
  padding: 5px 10px;
  margin-bottom: 15px;
`

const SectionTitle = styled(ParagraphSmallCaps)(({ opacify, theme, vAlignCenter }) => css`
  color: ${Color(theme.white).alpha(opacify ? theme.labelOpacity : 1).toString()};
  display: ${vAlignCenter ? 'flex' : 'block'};
  align-items: ${vAlignCenter ? 'center' : 'initial'};
`)

export {
  SectionTitle,
  SectionTitleContainer
}
